<ng-container *ngVar="(route$ | async) as route">
  <ng-container *ngIf="!route?.isLogin">
    <app-top-bar></app-top-bar>
    <side-bar *ngIf="!route?.isSearch"></side-bar>
    <app-side-bar-search *ngIf="route?.isSearch"></app-side-bar-search>
  </ng-container>
  <div id="eeh-navigation-page-wrapper">
    <div class="page-content-wrapper">
      <ng-content></ng-content>
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>
